
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    iskey: {
      type: Boolean,
      default: false
    }
  }
}
